'use strict';

var React = require('react');

var SvgAccessibilityMajor = function SvgAccessibilityMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 18c-7.666 0-9.939-7.648-9.962-7.726a1 1 0 0 1 0-.548c.023-.078 2.296-7.726 9.962-7.726 7.633 0 9.927 6.617 9.948 6.684a1 1 0 1 1-1.895.635 8.348 8.348 0 0 0-8.053-5.319c-5.467 0-7.513 4.772-7.948 6 .434 1.225 2.479 6 7.948 6a1 1 0 0 1 0 2zm0-4c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4a1 1 0 1 1-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2a1 1 0 0 1 0 2zm5 4a.997.997 0 0 1-.707-.293l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a.995.995 0 0 1-.707.293z"
  }));
};

exports.SvgAccessibilityMajor = SvgAccessibilityMajor;
